<template>
  <div class="flex">
    <div v-for="(tag, i) in tagCounts" :key="i">
      <div style="padding-left:10px" class="flex ">
        <div>
          <img v-if="!largeIcon && !emoji" width="30" :src="getIcon(tag.tag)" />
          <img v-if="largeIcon && !emoji" width="40" :src="getIcon(tag.tag)" />
          <div v-if="!largeIcon && emoji" style="font-size: 25px; line-height: 1; overflow: hidden;">
            {{ emoji }}
          </div>
          <div v-if="largeIcon && emoji" style="font-size: 35px; line-height: 1; overflow: hidden;">
            {{ emoji }}
          </div>
        </div>
        <h3 v-if="tag.count > 1">
          {{ tag.count }}
        </h3>
        <!-- <div v-if="tag.desc">
          {{ tag.desc }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import DisplayTagsVue from './DisplayTags.vue'

export default {
  props: {
    TagsList: Array,
    LargeIcon: Boolean,
    Emoji: String
  },
  setup(props) {

    const tagCounts = []
    const largeIcon = props.LargeIcon;
    const emoji = props.Emoji;
    props.TagsList.forEach((tag) => {
      let index = tagCounts.findIndex((tagg) => tagg.tag === tag)

      if (index === -1) {
        tagCounts.push({ tag, count: 1 })
      } else {
        tagCounts[index].count++
      }
    })

    // const TagsList = props.params.data.ModelTags.TagsList

    function getIcon(modelType) {
      try {
        return require(`../../assets/icons/${modelType.toLowerCase()}.png`) //note backticks used for String interpolation
      } catch (error) {
        console.log(error)
        return require(`../../assets/icons/email.png`)
      }
    }
    return { getIcon, tagCounts, largeIcon, emoji }
  }
}
</script>

<style></style>
